import { Center, Flex, Text} from "@chakra-ui/react";
import React from "react";
import LoadingSpinner from "../LoadingSpinner";

export default function Loading(props){

    return(
        <Center minH={"75vh"} color="black" rounded={20} m={[0, 10]} boxShadow={40}>
            <Flex flexDir={"row"}>
                <Flex mb={5}  flexDir={"column"}  alignContent={"center"} data-testid="loading-spinner">
                    <LoadingSpinner  />

                </Flex>
                <Flex mb={5}>
                    <Text textAlign={"center"} fontSize={["xl","2xl"]}>Carregando...</Text>
                </Flex>


            </Flex>
        </Center>
    )

}